/* -----------------------
  CLASSIC - Page Default
/* ------------------------ */
function defaultTitle() {
  if ($(window).width() < 768) {
    var replaceTitle = $(".tickets_page .replace_mobile").html();
    $(".tickets_page h1").html(replaceTitle);
  }
};

/* -----------------------
  CLASSIC - Page Checkout - step 1
/* ------------------------ */
function mobileStructureCheckout() {
  if ($(window).width() < 768) {
    $("#checkout .col_tickets .btn_zone").appendTo($("#checkout"));
    $("#checkout .payment_info").appendTo($("#checkout #ticketing"));
  } else {
    $("#checkout .col_tickets .btn_zone").appendTo($("#checkout .col_tickets"));
    $("#checkout .payment_info").appendTo($("#checkout .col_aside"));
  }
};

// Checkout order fixed bottom
function checkoutSubmitHeight() {
  if ($('#checkout').length > 0) {
    if ($(window).width() < 768 ) {
      var checkoutSubmitHeight = $('#checkout .btn_zone').outerHeight();
      $('#checkout').css({'padding-bottom': checkoutSubmitHeight + 'px'});
    }
  }
}

/* -----------------------
  VISITS - Page animations choice
/* ------------------------ */
function fixedFilters() {
  if ($(window).width() < 768) {
    var filtersHeight = $('#default.visits #filters').outerHeight();
    $('#default.visits').css({'padding-bottom': filtersHeight + 'px'});
  } else {
    $('#default.visits').css({'padding-bottom': 0 + 'px'});
  }
};

$(document).ready(function() {
  /* -----------------------
    Page Default
  /* ------------------------ */
  defaultTitle();

  /* -----------------------
    Page Checkout - step 1
  /* ------------------------ */
  mobileStructureCheckout();
  checkoutSubmitHeight();

  /* -----------------------
    VISITS - Page animations choice
  /* ------------------------ */
  fixedFilters();
});

$(window).resize(function() {
  /* -----------------------
    Page Default
  /* ------------------------ */
  defaultTitle();

  /* -----------------------
    Page Checkout - step 1
  /* ------------------------ */
  mobileStructureCheckout();
  checkoutSubmitHeight();

  /* -----------------------
    VISITS - Page animations choice
  /* ------------------------ */
  fixedFilters();
});